import React, { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/context';
import { MEASUREMENT_TYPE } from 'pages/dimensions/const';
import { MeasurementBanner as MeasurementBannerContent } from 'pages/common/components/MeasurementBanner';

export const MeasurementBanner = () => {
  const data = useContext(DataContext);
  const services = data?.surfaces?.services?.[0];
  const isShowMeasurementBanner = data?.surfaces.services?.length && services?.type === MEASUREMENT_TYPE;

  return (
    <>
      {isShowMeasurementBanner ? (
        <MeasurementBannerContent
          priceMin={services?.priceMin}
          serviceURL={services?.serviceURL}
          serviceName={services?.name}
        />
      ) : null}
    </>
  );
};
